import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';
import { urlPathname } from './shared/utils';

declare const window: Window;
const jQuery = window.jQuery;

export function setErrorMessage(message: string) {
  jQuery('#errormessage').removeClass('u-hide');
  jQuery('#errormessage').html(message);
  window.ctkerrormessage = message;
}

export function clearErrorMessage() {
  jQuery('#errormessage').addClass('u-hide');
  setErrorMessage('');
}

export function getValue(name: string) {
  const jq = jQuery('#form' + name);
  let val = jq.val();
  if (val && val.length > 0) {
    val = val.trim();
  }
  return val;
}

export function getCheckboxChecked(name: string) {
  const jq = jQuery('#form' + name);
  const val = jq.is(':checked');
  return val;
}

function showHideLabel(name: string) {
  return;
  if (getValue(name).trim() === '') {
    jQuery('label[for="form' + name + '"]').hide();
  } else {
    jQuery('label[for="form' + name + '"]').show();
  }
}

function setNotValid(name: string) {
  jQuery('#form' + name).addClass('notvalid');
}

function translateMessage(code: string) {
  const tr: any = {
    name: 'jméno',
    surname: 'příjmení',
    email: 'e-mail',
    phone: 'telefon',
    street: 'ulice',
    city: 'město',
    psc: 'PSČ',
    country: 'stát',
    ic: 'IČ',
    dic: 'DIČ',
    passwdold: 'původní heslo',
    passwd: 'heslo',
    passwd2: 'potvrzení hesla',
    passwddiff: 'rozdílná hesla',
    resetcode: 'kód z e-mailu',
    souhlas: 'souhlas s podmínkami',
    product: 'produkt',
  };

  let ret = 'neznámý kód chyby';
  if (tr[code]) {
    ret = tr[code];
  }
  return ret;
}

export function validateEmail(out: any) {
  const ret = [];
  let errorMessage = '';
  if (!urlPathname().includes('profile') && jQuery('#formemail').length > 0) {
    //exist (edit profile email not allowed
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        getValue('email').trim(),
      )
      // !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(        getValue('email').trim(),      )
    ) {
      ret.push('email');
      errorMessage = 'Vyplňte, prosím, správně e-mail!';
    }
  }
  showHideLabel('email');
  if (errorMessage !== '') {
    out.errorMessage = errorMessage;
  }
  ret.forEach((it) => out.invalidFields.push(it));
}

export function validateFakturace(out: any) {
  const ret = [];
  let errorMessage = '';
  if (getValue('name').trim().length < 2) {
    ret.push('name');
    errorMessage = 'Vyplňte, prosím, správně jméno!';
  }
  if (getValue('surname').trim().length < 2) {
    ret.push('surname');
    errorMessage = 'Vyplňte, prosím, správně příjmení!';
  }
  if (!/^\+?[0-9]{5,}$/.test(getValue('phone').trim())) {
    ret.push('phone');
    errorMessage = 'Vyplňte, prosím, správně telefon!';
  }
  if (getValue('street').trim().length < 2) {
    ret.push('street');
    errorMessage = 'Vyplňte, prosím, správně ulici!';
  }
  if (getValue('city').trim().length < 2) {
    ret.push('city');
    errorMessage = 'Vyplňte, prosím, správně město!';
  }
  if (!/^[0-9]{4,}$/.test(getValue('psc').trim())) {
    ret.push('psc');
    errorMessage = 'Vyplňte, prosím, správně PSČ!';
  }
  if (getValue('country').trim().length < 2) {
    ret.push('country');
    errorMessage = 'Vyplňte, prosím, správně stát!';
  }
  if (
    (getValue('ic').trim() !== '' &&
      !/^[0-9]{4,}$/.test(getValue('ic').trim())) ||
    (getValue('company').trim() !== '' && getValue('ic').trim() == '')
  ) {
    // if company exists, ic is mandatory
    ret.push('ic');
    errorMessage = 'Vyplňte, prosím, správně IČ, nebo smažte společnost!';
  }
  if (
    getValue('dic').trim() !== '' &&
    !/^([a-zA-Z]{2})?[-0-9]{4,}$/.test(getValue('dic').trim())
  ) {
    ret.push('dic');
    errorMessage = 'Vyplňte, prosím, správně DIČ!';
  }

  if (errorMessage !== '') {
    out.errorMessage = errorMessage;
  }
  ret.forEach((it) => out.invalidFields.push(it));
  showHideLabel('dic');
  showHideLabel('ic');
  showHideLabel('country');
  showHideLabel('psc');
  showHideLabel('city');
  showHideLabel('street');
  showHideLabel('phone');
  showHideLabel('surname');
  showHideLabel('name');
  showHideLabel('company');
}

export function validateProfilePart(variant: string, isSilent: boolean) {
  console.log('validate issilent' + isSilent + variant);
  const out = { errorMessage: '', invalidFields: [] };
  if (variant === 'all') {
    validateEmail(out);
    validateFakturace(out);
  }

  jQuery('.objednat input').removeClass('notvalid');

  const errorMessage = out.errorMessage;
  const ret = out.invalidFields;
  if (ret.length > 0 && !isSilent) {
    ret.forEach((it) => {
      setNotValid(it);
    });
  }

  if (variant === 'all' || variant === 'register') {
    if (errorMessage !== '') {
      jQuery('#formsubmit').addClass('notusable');
    } else {
      jQuery('#formsubmit').removeClass('notusable');
    }
  }
  if (isSilent !== true) {
    if (variant === 'fakturace') {
      if (errorMessage !== '') {
        jQuery('#formbuttonsaveuserinfo').addClass('notusable');
      } else {
        jQuery('#formbuttonsaveuserinfo').removeClass('notusable');
      }
    }
    if (errorMessage !== '') {
      if (out.invalidFields.length > 1) {
        setErrorMessage(
          'Je potřeba vyplnit ještě tyto položky: ' +
            out.invalidFields.map((it) => translateMessage(it)).join(', '),
        );
      } else {
        setErrorMessage(errorMessage);
      }
    } else {
      clearErrorMessage();
    }
  }
}
